// React 19 は ReactDOM.findDOMNode を削除したが、react-sortable-tree（dist）と
// frontend-collective-react-dnd-scrollzone がドラッグ中に findDOMNode を呼ぶ。
// 実体の react-dom を 'react-dom-original'（vite.config.ts の alias で解決）経由で
// そのまま再エクスポートしつつ、最小実装の findDOMNode を追加する shim。
// createPortal / unstable_batchedUpdates など他の API は素通しする。
import * as ReactDOMOriginal from 'react-dom-original';

export * from 'react-dom-original';

const ReactDOM = ReactDOMOriginal.default ?? ReactDOMOriginal;
export default ReactDOM;

// DFS で次の fiber ノードを返す。root に戻ったら null。
const nextFiberNode = (node, root) => {
  if (node.child) return node.child;
  let current = node;
  while (current && !current.sibling) {
    if (current === root) return null;
    current = current.return;
  }
  return current && current !== root ? current.sibling : null;
};

// クラスコンポーネントのインスタンス（react-virtualized.List 等）から fiber を辿り、
// 最初の Host(DOM) ノードを返す。Fragment・Context.Provider 等でラップされた場合も
// sibling を遡る DFS で正しく検出する。
export const findDOMNode = (instance) => {
  if (instance == null) return null;
  if (typeof instance.nodeType === 'number') return instance;
  const fiber = instance._reactInternals ?? instance._reactInternalFiber;
  if (fiber == null) return null;
  let node = fiber;
  while (node) {
    if (node.stateNode != null && typeof node.stateNode.nodeType === 'number') {
      return node.stateNode;
    }
    node = nextFiberNode(node, fiber);
  }
  return null;
};
